import { AddressCard } from "components";

function Location() {
  return (
    <div className="w-full flex flex-col">
      <div className="text-lg text-[#112211] font-semibold mb-8">
        Location/Map
      </div>
      <div className="bg-gray-200 w-full h-[700px] rounded-[16px] flex items-center justify-center">
        <div className="text-xl">Google map</div>
      </div>
      <AddressCard />
    </div>
  );
}
export default Location;
